
// import {
//   FETCH_LEAVES_REQUEST,
//   FETCH_LEAVES_SUCCESS,
//   FETCH_LEAVES_FAILURE,
//   UPDATE_LEAVE_STATUS_REQUEST,
//   UPDATE_LEAVE_STATUS_SUCCESS,
//   UPDATE_LEAVE_STATUS_FAILURE,
//   BULK_UPDATE_LEAVE_STATUS_REQUEST,
//   BULK_UPDATE_LEAVE_STATUS_SUCCESS,
//   BULK_UPDATE_LEAVE_STATUS_FAILURE,
//   UPDATE_LEAVE_REMARK_REQUEST,
//   UPDATE_LEAVE_REMARK_SUCCESS,
//   UPDATE_LEAVE_REMARK_FAILURE,
// } from "../actions/leaveActions";


// const initialState = {
//   leaves: [],
//   meta: {
//     page: 1,
//     limit: 10,
//     total: 0,
//   },
//   loading: false,
//   error: null,
// };

// const leaveReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_LEAVES_REQUEST:
//     case UPDATE_LEAVE_STATUS_REQUEST:
//     case UPDATE_LEAVE_REMARK_REQUEST:
//     case BULK_UPDATE_LEAVE_STATUS_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_LEAVES_SUCCESS: {
//       const { page, limit, total } = action.payload.meta;
//       const totalPages = Math.ceil(total / limit);

//       return {
//         ...state,
//         loading: false,
//         leaves: action.payload.data || [],
//         meta: {
//           page,
//           limit,
//           total,
//           totalPages,
//         },
//       };
//     }

//     case UPDATE_LEAVE_STATUS_SUCCESS:
//     case UPDATE_LEAVE_REMARK_SUCCESS:
//     case BULK_UPDATE_LEAVE_STATUS_SUCCESS:
//       return { ...state, loading: false };

//     case FETCH_LEAVES_FAILURE:
//     case UPDATE_LEAVE_STATUS_FAILURE:
//     case UPDATE_LEAVE_REMARK_FAILURE:
//     case BULK_UPDATE_LEAVE_STATUS_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default leaveReducer;

import {
  FETCH_LEAVES_REQUEST,
  FETCH_LEAVES_SUCCESS,
  FETCH_LEAVES_FAILURE,

  UPDATE_LEAVE_STATUS_REQUEST,
  UPDATE_LEAVE_STATUS_SUCCESS,
  UPDATE_LEAVE_STATUS_FAILURE,

  BULK_UPDATE_LEAVE_STATUS_REQUEST,
  BULK_UPDATE_LEAVE_STATUS_SUCCESS,
  BULK_UPDATE_LEAVE_STATUS_FAILURE,

  UPDATE_LEAVE_REMARK_REQUEST,
  UPDATE_LEAVE_REMARK_SUCCESS,
  UPDATE_LEAVE_REMARK_FAILURE,

  UPDATE_LEAVE_REQUEST,
  UPDATE_LEAVE_SUCCESS,
  UPDATE_LEAVE_FAILURE,

} from "../actions/leaveActions";


/* =====================================
   INITIAL STATE
===================================== */
const initialState = {
  leaves: [],
  meta: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};


/* =====================================
   REDUCER
===================================== */
const leaveReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ===============================
       REQUEST STATES
    =============================== */
    case FETCH_LEAVES_REQUEST:
    case UPDATE_LEAVE_STATUS_REQUEST:
    case UPDATE_LEAVE_REMARK_REQUEST:
    case BULK_UPDATE_LEAVE_STATUS_REQUEST:
    case UPDATE_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };


    /* ===============================
       FETCH LEAVES SUCCESS
    =============================== */
    case FETCH_LEAVES_SUCCESS: {
      const { page, limit, total } = action.payload.meta;
      const totalPages = Math.ceil(total / limit);

      return {
        ...state,
        loading: false,
        leaves: action.payload.data || [],
        meta: {
          page,
          limit,
          total,
          totalPages,
        },
      };
    }


    /* ===============================
       UPDATE LEAVE (NEW API)
       Updates start_date/end_date/status
    =============================== */
    case UPDATE_LEAVE_SUCCESS: {
      const updatedLeave = action.payload;

      // If API does not return row
      if (!updatedLeave) {
        return { ...state, loading: false };
      }

      return {
        ...state,
        loading: false,
        leaves: state.leaves.map((leave) =>
          leave.id === updatedLeave.id
            ? { ...leave, ...updatedLeave }
            : leave
        ),
      };
    }


    /* ===============================
       UPDATE STATUS SUCCESS
    =============================== */
    case UPDATE_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };


    /* ===============================
       UPDATE REMARK SUCCESS
    =============================== */
    case UPDATE_LEAVE_REMARK_SUCCESS:
      return {
        ...state,
        loading: false,
      };


    /* ===============================
       BULK UPDATE SUCCESS
    =============================== */
    case BULK_UPDATE_LEAVE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };


    /* ===============================
       FAILURE STATES
    =============================== */
    case FETCH_LEAVES_FAILURE:
    case UPDATE_LEAVE_STATUS_FAILURE:
    case UPDATE_LEAVE_REMARK_FAILURE:
    case BULK_UPDATE_LEAVE_STATUS_FAILURE:
    case UPDATE_LEAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };


    /* ===============================
       DEFAULT
    =============================== */
    default:
      return state;
  }
};

export default leaveReducer;